import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HeaderBread from "../../../components/HeaderBread";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";

import { message } from "antd";
import Swal from "sweetalert2";
import YouTubeEmbed from "../../../components/Banner/YouTubeEmbed";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import ActiveSwitchFile from "../../../components/SwitchFile";
import CustomizedTable from "../../../components/UI/CustomizedTable";
import { constants } from "../../../constants/constants";
import DeletePop from "../../../constants/ErrorPermissionModal";
import {
  deleteCrisisPopup,
  getCrisisPopup,
  updateCrisisPopup,
} from "../../../utils/ApiCalls/CrisisPopup";
import { addlog } from "../../../utils/ApiCalls/Logs";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import { LOG_ACTIONS } from "../../../utils/Constant/LogConstant";
import Logs from "../../../components/Logs";
import SwitchBar from "../../../components/Pages/SwitchBar";


const CrisisPopup = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState("listing");
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Crisis Popup",
      route: "/website/cms/crisis-page/crisis-popup",
    },
  ];
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [{ userDetails,permission }, dispatch] = useDataLayerValue();

  
  const locationP = useLocation();

  const [page, setPage] = useState(
    () => parseInt(new URLSearchParams(locationP.search).get("page")) || 1
  );
  const [pageSize, setPageSize] = useState(
    () => parseInt(new URLSearchParams(locationP.search).get("pageSize")) || 10
  );
  const [search, setSearch] = useState(
    () => new URLSearchParams(locationP.search).get("search") || ""
  );

  useEffect(() => {
    const params = new URLSearchParams(locationP.search);
    const pageParam = parseInt(params.get("page")) || 1;
    const pageSizeParam = parseInt(params.get("pageSize")) || 10;
    const searchParam = params.get("search") || "";

    // setPage(pageParam);
    // setPageSize(pageSizeParam);
    setSearch(searchParam);
  }, [locationP.search]);

  useEffect(() => {
    const params = new URLSearchParams();
    const currentParams = new URLSearchParams(locationP.search);

    params.set("page", page);
    params.set("pageSize", pageSize);
    if (search) params.set("search", search);

    if (currentParams.toString() !== params.toString()) {
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [page, pageSize, search, navigate, locationP.search]);


  const columns = [
    {
      title: "Sl",
      width: 30,
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (position, record, index) => (page - 1) * pageSize + index + 1,
    },
     {
            title: "Image",
            width: 30,
            dataIndex: "image",
            key: "image",
            render: (image, record) => {
              if (record.content_type === "video") {
                return (
                  <video
                    src={`${constants.MEDIAURL}/${image}`}
                    style={{ width: "100px", height: "80px" }}
                  >
                    <track kind="captions" src="" label="English captions" />
                  </video>
                );
              } else if (record.content_type === "link") {
                return (
                  <YouTubeEmbed
                    videoUrl={`${constants.MEDIAURL}/${image}`}
                    width="100px"
                    height="80px"
                  />
                );
              } else {
                return (
                  <img
                    alt="banner"
                    src={`${constants.MEDIAURL}/${image}`}
                    style={{ width: "100px", height: "80px" }}
                  />
                );
              }
            },
          },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 50,
      render:(item)=><div dangerouslySetInnerHTML={{__html:item}}/>
    },

       {
        title: "Status",
        dataIndex: "is_active",
        key: "is_active",
        width: 30,
        sorter: (a, b) => "",
        render: (item, record, index) => (
          <ActiveSwitchFile
            item={item}
            record={record}
            index={index}
            handleUpdate={handleUpdate}
          />
        ),
      },
    {
      title: "Action",
      key: "operation",
      width: 100,
      render: (text, record) => (
        <div className="table_action_btn">
          <button className="btn" onClick={() => handleEdit(record.id)}>
            <i
              className="ri-edit-2-line"
              data-toggle="tooltip"
              title="Edit"
            ></i>
          </button>
          <DeletePop onConfirm={() => handleDelete(record.id)}>
            <div>
              {" "}
              <button className="btn delete_btn">
                <i
                  className="ri-delete-bin-line"
                  data-toggle="tooltip"
                  title="Delete"
                ></i>
              </button>
            </div>
          </DeletePop>
        </div>
      ),
    },
  ];
  useEffect(() => {
    getData(page);
  }, [page, pageSize]);
  const handleUpdate = async (id, values, title, location_id) => {
    if (checkPermission(permission, "update_per", "Crisis Popup",window?.location?.pathname)) {
      let data = await updateCrisisPopup(id, values);
      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.error,
        });
      } else {
        addlog(
          "Crisis Popup " +
            (!values.valid_from
              ? values.is_active === 1
                ? LOG_ACTIONS.ACTIVATED
                : LOG_ACTIONS.DEACTIVATED
              : LOG_ACTIONS.UPDATED),
          "Crisis Popup",
          { ...values, id, title, location_id },
          userDetails.id
        );
      }
      getData(page);
    } else {
      message.error("Update permission missing");
    }
  };
  const getData = async (value) => {
    let data = await getCrisisPopup({ page: value, limit: pageSize });
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
  };
  const handleEdit = async (id) => {
    if (checkPermission(permission, "update_per", "Crisis Popup",window?.location?.pathname)) {
      navigate("/website/cms/crisis-page/crisis-popup/edit/" + id);
    } else {
      message.error("Update permission missing");
    }
  };
  const handleDelete = async (id) => {
    if (checkPermission(permission, "delete_per", "Crisis Popup",window?.location?.pathname)) {
      await deleteCrisisPopup(id);
      addlog("Crisis Popup Deleted", "Crisis Popup", { id }, userDetails.id);
      getData();
    } else {
      message.error("Missing Permission for delete");
    }
  };

  return (
    <Layout type={"read_per"} module_data={"Crisis Popup"}>
      <CustomHeaderTitle title={"Crisis Popup"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={"Crisis Popup"}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <SwitchBar
              tabs={[
                { title: "Crisis Popup List", value: "listing" },
                { title: "History Logs", value: "logs" },
              ]}
              activeTab={active}
              setActiveTab={setActive}
            />
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item">
                  <h5 className="card-title">Crisis Popup List</h5>
                  <div className="two_item">
                    <Link
                      to="/website/cms/crisis-page/crisis-popup/add"
                      className="btn add_v_btn mx-2"
                    >
                      Add Crisis Popup
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table_holder">
                    <CustomizedTable
                      setRows={setRows}
                      setPageSize={setPageSize}
                      setPage={setPage}
                      pageSize={pageSize}
                      page={page}
                      count={count}
                      columns={columns}
                      rows={rows}
                      title={"Crisis Popup"}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
        {active === "logs" && <Logs type={"Crisis Popup"} />}
      </div>
    </Layout>
  );
};

export default CrisisPopup;
